"use client";

import { c as _c } from "react/compiler-runtime";
import PostCard from "@/components/posts/PostCard";
import { useLanguage } from "@/contexts/LanguageContext";
import type { PostMeta } from "@/lib/posts";
interface PostListClientProps {
  posts: PostMeta[];
}
export default function PostListClient(t0) {
  const $ = _c(19);
  const {
    posts
  } = t0;
  const {
    language,
    t
  } = useLanguage();
  let t1;
  let t2;
  let t3;
  if ($[0] !== language || $[1] !== posts || $[2] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t4;
      if ($[6] !== language) {
        t4 = post => post.language === language;
        $[6] = language;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      const filteredPosts = posts.filter(t4);
      if (posts.length === 0) {
        let t5;
        if ($[8] !== t) {
          t5 = t("posts.empty");
          $[8] = t;
          $[9] = t5;
        } else {
          t5 = $[9];
        }
        let t6;
        if ($[10] !== t5) {
          t6 = <div className="py-20 text-center"><p className="text-lg text-text-secondary">{t5}</p></div>;
          $[10] = t5;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        t3 = t6;
        break bb0;
      }
      if (filteredPosts.length === 0) {
        let t5;
        if ($[12] !== t) {
          t5 = t("posts.emptyLanguage");
          $[12] = t;
          $[13] = t5;
        } else {
          t5 = $[13];
        }
        let t6;
        if ($[14] !== t5) {
          t6 = <div className="py-20 text-center"><p className="text-lg text-text-secondary">{t5}</p></div>;
          $[14] = t5;
          $[15] = t6;
        } else {
          t6 = $[15];
        }
        t3 = t6;
        break bb0;
      }
      t1 = "grid gap-8 sm:grid-cols-2 lg:grid-cols-3";
      t2 = filteredPosts.map(_temp);
    }
    $[0] = language;
    $[1] = posts;
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
function _temp(post_0) {
  return <PostCard key={post_0.slug} post={post_0} />;
}